module.exports = "./img/6557448c1a745dbda837751bb0d5eb78.png";